function updatePurchaseInput(input, value) {
  if (!input || value === null || value === undefined || value === '') return;

  input.disabled = false;
  if (input.value === String(value)) return;

  input.value = String(value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

const PALBEING_STICKY_FIX_VERSION = '2026-09-05-v4';

function getStickyProductInfo(source) {
  return (
    (source && source.closest && source.closest('product-info')) ||
    document.querySelector('product-info')
  );
}

function getStickyPurchaseParts(productInfo) {
  if (!productInfo) return {};

  const mainProductForm = productInfo.querySelector('product-form.product-form');
  const mainForm =
    mainProductForm &&
    mainProductForm.querySelector('form[action*="/cart/add"]');
  const stickyCart = productInfo.querySelector('.product-sticky-cart');
  const stickyForm =
    stickyCart && stickyCart.querySelector('form[action*="/cart/add"]');

  return {
    mainForm,
    mainQuantity:
      mainForm &&
      Array.from(mainForm.elements).find(input => input.name === 'quantity' && !input.classList.contains('quantity__input-sticky')),
    mainVariant: mainForm && mainForm.querySelector('input[name="id"]'),
    mainBuyNow: mainForm && mainForm.querySelector('#flo-buy-now-button'),
    mainButtons:
      mainProductForm &&
      mainProductForm.querySelector('.product-form__buttons'),
    stickyCart,
    stickyForm,
    stickyVariant: stickyForm && stickyForm.querySelector('input[name="id"]'),
    stickyWrapper:
      stickyCart && stickyCart.closest('animate-sticky.sticky-cart-wrapper'),
  };
}

function ensureStickyQuantity(stickyForm) {
  if (!stickyForm) return null;

  let stickyQuantity = stickyForm.querySelector('input[name="quantity"]');
  if (!stickyQuantity) {
    stickyQuantity = document.createElement('input');
    stickyQuantity.type = 'hidden';
    stickyQuantity.name = 'quantity';
    stickyQuantity.value = '1';
    stickyQuantity.className = 'quantity__input-sticky';

    const variantInput = stickyForm.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.insertAdjacentElement('afterend', stickyQuantity);
    } else {
      stickyForm.prepend(stickyQuantity);
    }
  }

  return stickyQuantity;
}

function selectedStickyPack(productInfo, mainQuantity) {
  const selectedOption =
    productInfo &&
    productInfo.querySelector('[data-pb-sticky-pack-option].is-active');
  const selectedPack = Number(selectedOption && selectedOption.dataset.pack);

  if (selectedPack >= 2) return 2;
  if (selectedPack === 1) return 1;

  return Number(mainQuantity && mainQuantity.value) >= 2 ? 2 : 1;
}

function renderStickyPack(productInfo, pack) {
  if (!productInfo) return;

  const selectedPack = Number(pack) >= 2 ? 2 : 1;
  const packBar = productInfo.querySelector('[data-pb-sticky-packbar]');
  if (!packBar) return;

  packBar.querySelectorAll('[data-pb-sticky-pack-option]').forEach((option) => {
    const isActive = Number(option.dataset.pack) === selectedPack;
    option.classList.toggle('is-active', isActive);
    option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  const title = packBar.querySelector('[data-pb-sticky-pack-title]');
  const price = packBar.querySelector('[data-pb-sticky-pack-price]');
  const selectedPrice = packBar.querySelector(
    `[data-pb-sticky-option-price="${selectedPack}"]`
  );

  if (title) title.textContent = `PACK OF ${selectedPack}`;
  if (price && selectedPrice) {
    price.textContent = selectedPrice.textContent.trim();
  }

  const trigger = packBar.querySelector('[data-pb-sticky-pack-trigger]');
  const panel = packBar.querySelector('[data-pb-sticky-pack-panel]');
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
  if (panel) panel.hidden = true;
}

function applyStickyPack(productInfo, pack, updateMainQuantity = true) {
  const selectedPack = Number(pack) >= 2 ? 2 : 1;
  const parts = getStickyPurchaseParts(productInfo);
  const root = productInfo && productInfo.querySelector('[data-pb-pack-version]');
  if (root && root.pbChoosePack) {
    root.pbChoosePack(selectedPack);
    renderStickyPack(productInfo, Number(root.dataset.selectedPack) || 1);
    return parts;
  }
  const stickyQuantity = ensureStickyQuantity(parts.stickyForm);

  if (updateMainQuantity) {
    updatePurchaseInput(parts.mainQuantity, selectedPack);
  }

  updatePurchaseInput(stickyQuantity, selectedPack);
  updatePurchaseInput(
    parts.stickyVariant,
    parts.mainVariant && parts.mainVariant.value
  );
  renderStickyPack(productInfo, selectedPack);

  return parts;
}

function toggleStickyPackPanel(trigger) {
  const packBar = trigger && trigger.closest('[data-pb-sticky-packbar]');
  const panel = packBar && packBar.querySelector('[data-pb-sticky-pack-panel]');
  if (!panel) return;

  const shouldOpen = panel.hidden;
  panel.hidden = !shouldOpen;
  trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
}

function installStickyVisibility(productInfo) {
  const parts = getStickyPurchaseParts(productInfo);
  const wrapper = parts.stickyWrapper;
  const mainButtons = parts.mainButtons;

  if (!wrapper || !mainButtons || wrapper.dataset.pbVisibilityFix === PALBEING_STICKY_FIX_VERSION) {
    return;
  }

  wrapper.dataset.pbVisibilityFix = PALBEING_STICKY_FIX_VERSION;

  let desiredVisible = false;
  let frameRequested = false;

  const applyVisibility = () => {
    frameRequested = false;

    const rect = mainButtons.getBoundingClientRect();

    // Keep the sticky cart hidden while the main purchase controls are either
    // visible or still below the viewport. Show it only after they have
    // completely scrolled above the top edge.
    desiredVisible = rect.bottom <= 0;
    if (wrapper.hasAttribute('animate') !== desiredVisible) {
      wrapper.toggleAttribute('animate', desiredVisible);
    }
  };

  const scheduleVisibility = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(applyVisibility);
  };

  window.addEventListener('scroll', scheduleVisibility, { passive: true });
  window.addEventListener('resize', scheduleVisibility);
  window.addEventListener('pageshow', scheduleVisibility);

  if ('IntersectionObserver' in window) {
    const purchaseObserver = new IntersectionObserver(scheduleVisibility, {
      threshold: [0, 0.01, 1],
    });
    purchaseObserver.observe(mainButtons);
  }

  const wrapperObserver = new MutationObserver(() => {
    if (wrapper.hasAttribute('animate') !== desiredVisible) {
      scheduleVisibility();
    }
  });
  wrapperObserver.observe(wrapper, {
    attributes: true,
    attributeFilter: ['animate'],
  });

  applyVisibility();
}

function initializeStickyCartFix() {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    const parts = getStickyPurchaseParts(productInfo);
    if (!parts.stickyCart) return;

    ensureStickyQuantity(parts.stickyForm);
    renderStickyPack(
      productInfo,
      selectedStickyPack(productInfo, parts.mainQuantity)
    );
    installStickyVisibility(productInfo);
  });
}

function openShopfloFromSticky(stickyBuyNow) {
  if (stickyBuyNow.disabled || stickyBuyNow.dataset.pbCheckoutBusy === 'true') {
    return;
  }

  const productInfo = getStickyProductInfo(stickyBuyNow);
  const currentParts = getStickyPurchaseParts(productInfo);
  const pack = selectedStickyPack(productInfo, currentParts.mainQuantity);
  const parts = applyStickyPack(productInfo, pack, true);

  stickyBuyNow.dataset.pbCheckoutBusy = 'true';
  stickyBuyNow.setAttribute('aria-busy', 'true');

  const releaseButton = () => {
    delete stickyBuyNow.dataset.pbCheckoutBusy;
    stickyBuyNow.removeAttribute('aria-busy');
  };

  const launchShopflo = (attempt = 0) => {
    if (typeof window.handleFloBuyNowBtn === 'function') {
      if (parts.mainBuyNow && parts.mainBuyNow !== stickyBuyNow) {
        parts.mainBuyNow.click();
      } else {
        window.handleFloBuyNowBtn({
          currentTarget: stickyBuyNow,
          target: stickyBuyNow,
          preventDefault() {},
          stopPropagation() {},
        });
      }

      window.setTimeout(releaseButton, 3000);
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => launchShopflo(attempt + 1), 100);
      return;
    }

    releaseButton();
    console.error(
      'Palbeing sticky cart: Shopflo is not ready. Checkout was not redirected to Shopify.'
    );
  };

  launchShopflo();
}

if (!window.__PB_STICKY_CART_FIX_V2_INSTALLED__) {
  window.__PB_STICKY_CART_FIX_V2_INSTALLED__ = true;
  window.__PB_STICKY_CART_FIX_VERSION__ = PALBEING_STICKY_FIX_VERSION;

  window.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-pb-sticky-pack-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleStickyPackPanel(trigger);
        return;
      }

      const option = event.target.closest('[data-pb-sticky-pack-option]');
      if (option) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const productInfo = getStickyProductInfo(option);
        applyStickyPack(productInfo, Number(option.dataset.pack), true);
        return;
      }

      const stickyBuyNow = event.target.closest(
        '[data-palbeing-shopflo-buy-now]'
      );
      if (!stickyBuyNow) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openShopfloFromSticky(stickyBuyNow);
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.matches('input[name="quantity"]')) return;
      if (event.target.closest('.product-sticky-cart')) return;

      const productInfo = event.target.closest('product-info');
      if (!productInfo || productInfo.querySelector('[data-pb-pack-version]')) return;
      const parts = getStickyPurchaseParts(productInfo);
      if (!productInfo.querySelector('[data-pb-sticky-packbar]')) {
        updatePurchaseInput(ensureStickyQuantity(parts.stickyForm), event.target.value);
        return;
      }
      window.requestAnimationFrame(() => {
        applyStickyPack(
          productInfo,
          Number(event.target.value) >= 2 ? 2 : 1,
          false
        );
      });
    },
    true
  );
}

/**
 * Palbeing sells the larger size on the website. Product forms expose that
 * permitted variant through a data attribute rendered by buy-buttons.liquid.
 * Keep the form and URL on that variant even if an old ad/bookmark contains a
 * smaller variant ID or a theme/app tries to restore the first variant.
 */
function enforcePalbeingWebsiteVariant() {
  const productForms = document.querySelectorAll(
    'product-form[data-palbeing-website-variant-id]'
  );
  if (!productForms.length) return;

  productForms.forEach((productForm) => {
    const websiteVariantId = productForm.dataset.palbeingWebsiteVariantId;
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!websiteVariantId || !variantInput) return;

    if (variantInput.value !== websiteVariantId) {
      variantInput.value = websiteVariantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  if (!document.body.classList.contains('template-product')) return;

  const websiteVariantId = productForms[0].dataset.palbeingWebsiteVariantId;
  const currentUrl = new URL(window.location.href);
  const requestedVariantId = currentUrl.searchParams.get('variant');
  if (requestedVariantId && requestedVariantId !== websiteVariantId) {
    currentUrl.searchParams.set('variant', websiteVariantId);
    window.history.replaceState({}, '', currentUrl);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      enforcePalbeingWebsiteVariant();
      initializeStickyCartFix();
    },
    { once: true }
  );
} else {
  enforcePalbeingWebsiteVariant();
  initializeStickyCartFix();
}

document.addEventListener('variant:change', () => {
  window.requestAnimationFrame(() => {
    enforcePalbeingWebsiteVariant();
    initializeStickyCartFix();
  });
});

